import { useScrollParentForChild } from "@hooks";
import { AddInviteesCardContent, ModalPageBottom } from "@organisms";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { PersonLike } from "@lib/infrastructure";
import { StyledModalPage } from "./styles";
import { AvailableRoomBookingState } from "./hooks/useAvailableRoomBookingState";

export const AvailableRoomAttendeesModalPage = ({
  bookingState,
  onBack,
  onClose,
}: {
  bookingState: AvailableRoomBookingState;
  onBack: () => void;
  onClose: () => void;
}) => {
  const { t } = useTranslation();
  const { invitees, setInvitees } = bookingState;
  const [localInvitees, setLocalInvitees] = useState<PersonLike[]>(invitees);

  const [selectedInvitee, setSelectedInvitee] = useState<number | undefined>(undefined);
  const [scrollRef, childWrapperRef] = useScrollParentForChild(selectedInvitee);

  return (
    <StyledModalPage
      onBack={onBack}
      onClose={onClose}
      title={t("screen:Invitees")}
      bottom={
        <ModalPageBottom
          className="border-t"
          buttonLabel={t("Save")}
          onClick={() => {
            setInvitees(localInvitees);
            onBack();
          }}
        />
      }>
      <div
        ref={scrollRef}
        className={"px-[var(--padding-x)] py-[var(--padding-y)]"}>
        <AddInviteesCardContent
          childWrapperRef={childWrapperRef}
          invitees={localInvitees}
          setInvitees={setLocalInvitees}
          setSelectedInvitee={setSelectedInvitee}
          selectedInvitee={selectedInvitee}
        />
      </div>
    </StyledModalPage>
  );
};
